import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TextTemplateTypeModel } from 'src/app/models/text-templates/text-template-type.model';
import { TextTemplateModel } from 'src/app/models/text-templates/text-template.model';
import { LoadingService } from 'src/app/services/loading.service';
import { TextTemplateService } from 'src/app/services/text-template.service';

@Component({
  selector: 'app-text-template-selector',
  standalone: false,
  templateUrl: './text-template-selector.component.html',
  styleUrl: './text-template-selector.component.scss',
})
export class TextTemplateSelectorComponent {
  @Input() type!: TextTemplateTypeModel;

  @Input() content: string | null = null;
  @Output() contentChange = new EventEmitter<string>();

  templates: TextTemplateModel[] = [];
  showSaveTemplateModal: boolean = false;

  selectedId: string | null = null;

  constructor(
    private textTemplateService: TextTemplateService,
    private loadingService: LoadingService
  ) {}

  ngOnInit() {
    this.loadTextTemplates();
  }

  hasContent(html: string | null | undefined): boolean {
    if (!html) return false;

    const text = html
      .replace(/<[^>]*>/g, '')  // remove HTML tags
      .replace(/&nbsp;/g, ' ')  // handle spaces
      .trim();

    return text.length > 0;
  }

  onTextTemplateSaved(template: TextTemplateModel) {
    this.selectedId = template.id;
    this.loadTextTemplates();
  }

  loadTextTemplates() {
    this.loadingService.load(
      this.textTemplateService.getTextTemplatesByType(this.type)
    ).subscribe(templates => {
      this.templates = templates;
    });
  }

  onTemplateChanged(e: any) {
    const template = this.templates.find(
      x => x.id === e.value
    );

    if (!template) {
      return;
    }

    this.content = template.content;
    this.contentChange.emit(this.content);
  }

  onSaveClick(): void {
    this.showSaveTemplateModal = true;
  }
}